import * as React from 'react'
import { useCallback } from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import Checkbox from '@mui/material/Checkbox'
import { ILeadFormModel } from '../../typings'
import { useFormikContext } from 'formik'
import {
  addToPestFormField,
  addToPestPacHeader,
} from '@user/components/Settings/EntityFormSettings/constants'

export function AddToPestPacToggle() {
  const {
    values: { createNewLocation },
    setFieldValue,
  } = useFormikContext<ILeadFormModel>()

  const onChange = useCallback(
    (_e, checked: boolean) => setFieldValue(addToPestFormField, checked),
    [setFieldValue],
  )

  return (
    <FormControlLabel
      labelPlacement="end"
      label={<Typography variant="body2">{addToPestPacHeader}</Typography>}
      sx={{ marginBottom: 0, marginRight: 0 }}
      data-test-id="add-to-pest-pac-toggle"
      control={
        <Checkbox
          onClick={(evt) => evt.stopPropagation()}
          onChange={onChange}
          checked={createNewLocation}
          color="primary"
          size="small"
        />
      }
    />
  )
}
